import {
  Heart,
  Smile,
  Eye,
  HandHeart,
  Shield,
  Accessibility,
  DollarSign,
  Baby,
  Zap,
  Activity,
  Ribbon,
  Hospital,
  Video,
  Scale,
  Fingerprint,
  PawPrint,
  Bus,
  Bone,
  Sparkles,
  LifeBuoy,
  ShieldAlert,
  type LucideIcon,
} from "lucide-react";
import { getPlanTypeMeta } from "@shared/schemas/planTypes";

const ICONS: Record<string, LucideIcon> = {
  medical: Heart,
  dental: Smile,
  vision: Eye,
  life: HandHeart,
  add: ShieldAlert,
  std: Accessibility,
  ltd: Accessibility,
  fsa_health: DollarSign,
  fsa_dependent_care: Baby,
  accident: Zap,
  critical_illness: Activity,
  cancer: Ribbon,
  hospital_indemnity: Hospital,
  telehealth: Video,
  legal: Scale,
  id_theft: Fingerprint,
  pet: PawPrint,
  transit: Bus,
  chiropractic: Bone,
  acupuncture: Sparkles,
  eap: LifeBuoy,
  other: Shield,
};

export function getTypeIcon(planType: string | undefined | null): LucideIcon {
  const meta = getPlanTypeMeta(planType);
  return ICONS[meta.iconKey] ?? Shield;
}

// Re-export the closed-plan predicate so existing import sites
// (`import { isPlanCurrentlyAvailable } from "./typeIcons"`) keep working.
// The implementation lives in `./planAvailability.ts` so it can be unit-tested
// without pulling React / lucide-react.
export { isPlanCurrentlyAvailable } from "./planAvailability";

/**
 * The plan-type icon in its accent-coloured tile — the same treatment used for
 * coverage headings across the app. Sizes: "sm" for inline chips, "md" for card
 * headers.
 */
export function CoverageIcon({
  planType,
  size = "md",
  className = "",
}: {
  planType: string | undefined | null;
  size?: "sm" | "md";
  className?: string;
}) {
  const meta = getPlanTypeMeta(planType);
  const Icon = getTypeIcon(planType);
  const box = size === "sm" ? "h-7 w-7" : "h-8 w-8";
  const glyph = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <span className={`inline-flex items-center justify-center rounded-lg ${box} ${meta.accentBg} ${className}`}>
      <Icon className={`${glyph} ${meta.accentText}`} />
    </span>
  );
}
